import React from "react";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import {
  PRICE_DISPLAY,
  PriceDisplay,
} from "../cfsSurvey/priceDisplay";

const SHOW = "show";
const HIDE = "hide";

interface Props {
  value: PriceDisplay;
  onChange: (value: PriceDisplay) => void;
}

const PriceDisplaySetting = ({ value, onChange }: Props) => {
  const isHidden = value === PRICE_DISPLAY.HIDDEN;

  return (
    <>
      <RadioGroup
        row
        name="price_visibility"
        value={isHidden ? HIDE : SHOW}
        onChange={(event) =>
          onChange(
            event.target.value === HIDE
              ? PRICE_DISPLAY.HIDDEN
              : PRICE_DISPLAY.EXACT
          )
        }
      >
        <FormControlLabel
          value={SHOW}
          control={<Radio color="primary" />}
          label="Show Price"
        />
        <FormControlLabel
          value={HIDE}
          control={<Radio color="primary" />}
          label="Hide Price"
        />
      </RadioGroup>
      {!isHidden && (
        <RadioGroup
          row
          name="price_display"
          value={value}
          onChange={(event) => onChange(event.target.value as PriceDisplay)}
        >
          <FormControlLabel
            value={PRICE_DISPLAY.EXACT}
            control={<Radio color="primary" />}
            label="Exact Price"
          />
          <FormControlLabel
            value={PRICE_DISPLAY.RANGE}
            control={<Radio color="primary" />}
            label="Price Range"
          />
        </RadioGroup>
      )}
    </>
  );
};

export default PriceDisplaySetting;
